import { html } from "lit";
var icon_doubleVerify_default = () => html`
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero">
      <path
        d="M3.07 24A1.1 1.1 0 0 1 2 22.88V10.13c0-.61.47-1.12 1.07-1.12.58 0 1.06.5 1.06 1.12v12.75C4.12 23.5 3.65 24 3.07 24" />
      <path
        d="M7.75 24H6.29a1.12 1.12 0 0 1 0-2.24h1.46a5.27 5.27 0 0 0 0-10.52H6.29A1.12 1.12 0 0 1 6.3 9h1.46c4.13 0 7.5 3.37 7.5 7.5a7.53 7.53 0 0 1-7.5 7.5" />
      <path
        d="M23.17 24c-.4 0-.8-.25-.98-.64L16.4 10.6a1.13 1.13 0 0 1 .53-1.49 1.08 1.08 0 0 1 1.44.55l5.78 12.75c.25.56 0 1.23-.53 1.48-.16.06-.31.1-.46.1" />
      <path
        d="M25.22 19.72a.9.9 0 0 1-.44-.11 1.15 1.15 0 0 1-.52-1.49L28 9.65c.24-.55.87-.8 1.4-.54.53.26.76.93.51 1.49l-3.72 8.46c-.19.41-.57.66-.96.66" />
    </g>
  </svg>
`;
export {
  icon_doubleVerify_default as default
};
//# sourceMappingURL=icon-doubleVerify.js.map
